import { Outlet } from 'react-router-dom'
import ErrorBoundary from '@/components/common/ErrorBoundary'
import Header from './Header'
import Footer from './Footer'

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex flex-col w-full max-w-[1500px] mx-auto px-4 pt-[var(--armory-sticky-gap)] pb-6 gap-6 sm:px-6 flex-1">
        <main className="flex-1 min-w-0">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <Footer />
    </div>
  )
}
